const scoreBarColors = [
  undefined,
  'hsl(var(--error-400))',
  'hsl(var(--warning-400))',
  'hsl(var(--success-800))',
  'hsl(var(--success-400))',
] as const;

export interface PasswordStrengthLabels {
  /** Labels for scores 0–4 */
  score: [string, string, string, string, string];
  /** Requirement text shown while password is below the minimum accepted threshold */
  minimum: string;
}

export interface PasswordStrengthProps {
  /** 0–4 strength score */
  score: number;
  meetsMinimum: boolean;
  /** Required labels for i18n */
  labels: PasswordStrengthLabels;
  /** Optional label above the strength meter */
  label?: string;
  /** Localized warning text */
  warning?: string | null;
}

export function PasswordStrength({
  score,
  meetsMinimum,
  labels,
  label,
  warning,
}: PasswordStrengthProps) {
  const clampedScore = Math.max(0, Math.min(4, score));
  const scoreLabels = labels.score;
  const minimumLabel = labels.minimum;

  return (
    <div className="space-y-1">
      {label ? (
        <div className="text-xs text-muted-foreground">
          <span>{label}</span>
        </div>
      ) : null}
      <div className="grid grid-cols-4 gap-1">
        {Array.from({ length: 4 }).map((_, index) => {
          const filled = index < clampedScore;
          return (
            <div
              key={index}
              className="h-1 rounded-full bg-muted"
              style={
                filled && scoreBarColors[clampedScore]
                  ? { backgroundColor: scoreBarColors[clampedScore] }
                  : undefined
              }
            />
          );
        })}
      </div>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        {!meetsMinimum ? <span>{minimumLabel}</span> : <span />}
        <span>{scoreLabels[clampedScore]}</span>
      </div>
      {warning ? <p className="text-xs text-muted-foreground">{warning}</p> : null}
    </div>
  );
}
